// 获取模块主要获取数据模块
import request from '@/utils/request';
// 获取数据
export const getAdminData = (current, size, name) => request({url: `/look/administratorManagement/getUserById?current=${current}&size=${size}&name=${name}`, method: 'get'});

// 获取下拉框数据
export const getSelectData = () => request({url: '/look/administratorManagement/getAdministratorOption', method: 'get'});

// 获取管理员详情
export const getAdminDetail = (id) => request({url: `/look/administratorManagement/getAdministratorDetails?id=${id}`, method: 'get'});

// 删除
export const deleteRowData = (data) => request({url: `/look/administratorManagement/deletetUserBatch`, method: 'delete', data});

// 添加管理员
export const addAdmin = (data) => request({url: '/look/administratorManagement/insertUser', method: 'post', data});

// 修改
export const changeAdmin = (data) => request({url: '/look/administratorManagement/updatetUser', method: 'put', data});

// 解锁
export const unlock = (id) => request({url: `/look/administratorManagement/updatetUserUnlock?id=${id}`, method: 'put'});

// 重置密码
export const reset = (id) => request({url: `/look/administratorManagement/updatetUserPassword?id=${id}`, method: 'put'});


// 获取富文本列表
export const getContentList = () => request({url: '/look/notice/getNoticeList', method: 'get'});
// 新增富文本
export const addContentItem = (data) => request({url: '/look/notice/addNotice', method: 'post', data});
// 更新富文本
export const editContentItem = (data) => request({url: '/look/notice/updateNotice', method: 'post', data});